import Styles from "./index.module.scss";

import { ReactComponent as ShowPassword } from '../../../../assets/icons/show-password.svg';
import { ReactComponent as ShowPasswordBlur } from '../../../../assets/icons/show-password-blur.svg';
import { ReactComponent as HidePassword } from '../../../../assets/icons/hide-password.svg';
import ErrorMsg from "../errorMsg";
import i18n from "../../../../utils/translations/i18n";

type TextBoxProps = {
    onClick?: (arg) => void;
    onChange?: (arg) => void;
    onBlur?: (arg) => void;
    onKeyDown?: (arg) => void;
    showPasswordHandler?: (arg) => void;
    className?: string;
    name?: string;
    value?: any;
    label?: string;
    type: string;
    id?: string;
    pattern?: string;
    isRequired?: boolean;
    disabled?: boolean
    placeholder?: string;
    defaultValue?: string
    dangerWarn?: boolean
    errorMessage?: string
    autoFocus?: boolean
    min?: number
    max?: number
    autocomplete?: any
    step?: number
    role?:string;
    showPasswordIcon?: boolean;
}

export const TextBox = ({ id, name, type, placeholder, onClick, onChange, onBlur, className, value, label, disabled, isRequired, dangerWarn, errorMessage, autoFocus, min, max, showPasswordHandler, showPasswordIcon = false }: TextBoxProps) => {
    const { t } = i18n;
    const handleOnChange = (event) => onChange?.(event);
    const handleOnBlur = (event) => onBlur?.(event);
    const inputClassName = `${className ? className : ''} ${dangerWarn ? Styles.dangerWarn : ''}`;

    const getPasswordIcon = () => {
        if (!value.length) return <ShowPasswordBlur />;
        return type === 'password' ? <ShowPassword /> : <HidePassword />;
    };

    return (
        <div className={Styles.textbox}>
            <input
                data-hj-suppress
                id={id}
                name={name}
                type={type}
                placeholder={placeholder}
                onClick={onClick}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                value={value}
                className={inputClassName}
                disabled={disabled}
                autoFocus={autoFocus}
                minLength={min}
                maxLength={max}
            />
            <label htmlFor={id}>
                {label}
                {
                    isRequired &&
                    <dfn title="required">
                        *
                    </dfn>
                }
            </label>
            {showPasswordIcon ?
                <div className={Styles.passwordIcon} onClick={() => { value.length && showPasswordHandler && showPasswordHandler(name) }} role="button" tabIndex={0} aria-label={value.length===0?t('sign-in.password_icon_aria_label_blured'):(type === 'password'?t('sign-in.password_icon_aria_label'):t('sign-in.password_icon_aria_label_hidden'))}>
                    {getPasswordIcon()}
                </div>
                :
                null}
            {errorMessage && <ErrorMsg fieldName={name} error={errorMessage}/>}
        </div>
    );
};

export default TextBox;
